import {Directive, EventEmitter, Input, Output} from '@angular/core';
import { GridFilterValue } from '@shared/models';
import { ColumnFilterConfig } from '../models/grid-column.model';

@Directive()
export class BaseGridFilter {
  @Input() public value: GridFilterValue;
  @Input() public config: ColumnFilterConfig;
  @Input() public name: string;

  @Output() public valueChange: EventEmitter<GridFilterValue> = new EventEmitter();
}
